<div class="magic-box-schedule-modal">
  <md-icon>schedule</md-icon> Schedule Magic Box
  <md-icon
    class="link playlistBase"
    (click)="ShowMbxSchedule()"
    mdTooltip="Show the current Magic Box Schedule queue"
  >
    playlist_base</md-icon
  >
  <br />
  <div class="gridVisi" *ngIf="gridVisible">
    <div
      class="tabSchedule ngx-datatable material striped fixed-header fixed-row virtualized"
      *ngIf="scheduleMbx.length > 0"
    >
      <ngx-datatable
        #table
        *ngIf="scheduleMbx !== null"
        [rows]="scheduleMbx"
        [columnMode]="'force'"
        [headerHeight]="40"
        [scrollbarV]="true"
        [footerHeight]="20"
        [rowHeight]="40"
        [externalSorting]="true"
        [reorderable]="false"
        [loadingIndicator]="loadingIndicator"
        class="scheduledata"
      >
        <ngx-datatable-column name="Language" prop="languageName" [width]="35">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>{{ row.language.value }}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="Channel"
          prop="channelName"
          [width]="30"
          [sortable]="false"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            {{ row.channel.value }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="Start Date"
          prop="displayStartDate"
          [width]="50"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            {{ row.displayStartDate }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="End Date"
          prop="displayEndDate"
          [width]="50"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            {{ row.displayEndDate }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
          <ng-template ngx-datatable-footer-template>
            <div class="footer-count" *ngIf="scheduleMbx.length > 0">
              {{ scheduleMbx.length }} Magic Box Schedule planned
            </div>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </div>
    <div *ngIf="scheduleMbx.length === 0">
      <div class="footer-count">
        {{ scheduleMbx.length }} Magic Box Schedule planned
      </div>
    </div>
  </div>
  <div class="link infoSchedule">
    <p (click)="ShowInformationSchedule()">
      <md-icon>live_help</md-icon>
      <strong><u>Show information on Magic Box Scheduling</u></strong>
    </p>
  </div>
  <div class="scheduleVisible" *ngIf="infoVisible">
    <p>To be applied, rules need to be scheduled :</p>
    <p>
      You have created a rule, in order to implement it,<br />
      you need to shedule it
    </p>
    <p>
      All the rules based on the language(s) & channel(s) selected <br />
      will be applied on the defined slot
    </p>
    <p>
      You can enter your email adress to be notified once the rule <br />
      is schedule at the end of the slot
    </p>
  </div>
  <app-spinner *ngIf="loading"></app-spinner>
  <form #scheduleForm="ngForm" md-card-content>
    <div class="section">
      <md-select
        name="language"
        [disabled]="loading"
        [(ngModel)]="schedule.languages"
        placeholder="Language(s)"
        [required]="true"
        (change)="getChannels()"
        [multiple]="true"
        #languagesSelect="ngModel"
      >
        <md-option disabled="disabled" style="margin-left: -36px; color: black">
          <md-checkbox
            name="selectAll"
            style="margin-left: 4px"
            color="accent"
            (change)="selectAllLanguages(languagesSelect, $event)"
            [checked]="allLanguagesSelected()"
            >All</md-checkbox
          >
        </md-option>
        <md-option disabled="disabled" style="margin-left: -36px; color: black">
          <md-checkbox
            name="popupCountries"
            style="margin-left: 4px"
            color="accent"
            (change)="selectPopupCountries(languagesSelect, $event)"
            [checked]="popupCountriesSelected()"
            >10 countries</md-checkbox
          >
        </md-option>
        <md-option *ngFor="let language of languages" [value]="language">{{
          language.value
        }}</md-option>
      </md-select>
      <div class="section">
        <md-select
          *ngIf="channels"
          name="channel"
          [disabled]="loading"
          [(ngModel)]="schedule.channels"
          placeholder="Channel(s)"
          (change)="CheckMagicBoxScheduleAvailibility()"
          [required]="true"
          [multiple]="true"
          #channelsSelect="ngModel"
        >
          <md-option
            disabled="disabled"
            style="margin-left: -36px; color: black"
          >
            <md-checkbox
              name="selectAll"
              style="margin-left: 4px"
              color="accent"
              (change)="selectAllChannels(channelsSelect, $event)"
              [checked]="allChannelsSelected()"
              >All</md-checkbox
            >
          </md-option>
          <md-option
            disabled="disabled"
            style="margin-left: -36px; color: black"
          >
            <md-checkbox
              name="linearChannels"
              style="margin-left: 4px"
              color="accent"
              (change)="selectLinearChannels(channelsSelect, $event)"
              [checked]="linearChannelsSelected()"
              >Linear channels</md-checkbox
            >
          </md-option>

          <md-option
            disabled="disabled"
            style="margin-left: -36px; color: black"
          >
            <md-checkbox
              name="digitalChannels"
              style="margin-left: 4px"
              color="accent"
              (change)="selectDigitalChannels(channelsSelect, $event)"
              [checked]="digitalChannelsSelected()"
              >Digital channels</md-checkbox
            >
          </md-option>
          <md-option *ngFor="let channel of channels" [value]="channel">{{
            channel.value
          }}</md-option>
        </md-select>
      </div>
    </div>

    <div class="section">
      <md2-datepicker
        name="startDate"
        [disabled]="loading"
        [(ngModel)]="schedule.startDate"
        format="dd/MM/y"
        placeholder="From"
        [openOnFocus]="true"
        (change)="dateChange()"
        [required]="true"
      >
      </md2-datepicker>
      <md2-datepicker
        name="endDate"
        [disabled]="loading"
        [(ngModel)]="schedule.endDate"
        format="dd/MM/y"
        placeholder="To"
        [min]="schedule.startDate"
        [openOnFocus]="true"
        (change)="dateChange()"
        [required]="true"
      >
      </md2-datepicker>
    </div>
    <div class="section">
      <md-form-field>
        <input
          mdInput
          name="email"
          placeholder="Email for notification"
          [(ngModel)]="schedule.email"
          [disabled]="loading"
        />
      </md-form-field>
    </div>
  </form>

  <span *ngIf="scheduleForm.valid && !canBeScheduled"
    >This schedule is already planned. Please check the list above.</span
  >
  <md-card-actions>
    <div class="actions">
      <button md-raised-button md-dialog-close [disabled]="loading">
        Cancel
      </button>
      <button
        md-raised-button
        (click)="saveSchedule()"
        color="accent"
        [disabled]="!scheduleForm.valid || loading || !canBeScheduled"
      >
        Submit
      </button>
    </div>
  </md-card-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/magic-box-schedule/magic-box-schedule.component.html